import { ColumnDef } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import api from "../../api/axios";
import { DataTable } from "../data-table/data-table";

export function Managers() {

    const [text, setText] = useState('');
    const [userForManager, setUserForManager] = useState<any>(null);
    const [manager, setManager] = useState<any[]>([]);

    const fetchManagers = async () => {
        try {
            const response = await api.get('/managers');

            if (response.status !== 200) {
                throw new Error('Network response was not ok');
            }

            setManager(response.data);
        } catch (error) {
            console.error('Error fetching managers:', error);
        }
    }

    useEffect(() => {
        fetchManagers();
    }, []);

    useEffect(() => {
        if (!text) {
            setUserForManager(null);
            return;
        }

        const timeout = setTimeout(() => {
            api.get(`/checkUserForManager/${text}`)
                .then(response => setUserForManager(response.data))
                .catch(error => console.error("Error fetching user:", error));
        }, 300);

        return () => clearTimeout(timeout);
    }, [text]);

    const columns: ColumnDef<any>[] = [
        {
            accessorKey: 'first_name',
            header: 'Vorname',
        },
        {
            accessorKey: 'last_name',
            header: 'Nachname',
        },
        {
            accessorKey: 'email',
            header: 'E-Mail',
        },
        {
            accessorKey: 'name',
            header: 'Unternehmen'
        }
    ];

    if (!manager || manager.length === 0) {
        return (
            <div className="managers">
                <p>Es wurden keine Manager gefunden.</p>
            </div>
        );
    }

    const makeManager = async () => {
        const result = await api.get(`/makeManager/${text}`);

        if (result.status === 200) {

            if (result.data.success === false) {
                alert("Es ist ein Fehler aufgetreten: Betroffene user: " + result.data.affected);
            } else {
                alert("Der Benutzer wurde erfolgreich zum Manager gemacht.");
            }
        } else {
            alert("Es ist ein Fehler aufgetreten. " + result.data);
        }

        setText('');
        setUserForManager(null);
        fetchManagers();
    }

    const removeManager = async () => {
        const result = await api.get(`/removeManager/${text}`);

        if (result.status === 200) {

            if (result.data.success === false) {
                alert("Es ist ein Fehler aufgetreten: Betroffene user: " + result.data.affected);
            } else {
                alert("Der Benutzer wurde erfolgreich als Manager entfernt.");
            }
        } else {
            alert("Es ist ein Fehler aufgetreten. " + result.data);
        }

        setText('');
        setUserForManager(null);
        fetchManagers();
    }

    const getUserForManager = () => {
        if (!userForManager) {
            return <></>;
        }

        if (userForManager.count === 0) {
            return <p>Es wurde kein Benutzer mit der E-Mail {text} gefunden.</p>;
        }

        if (userForManager.count > 1) {
            return <p>Es wurden {userForManager.count} Benutzer mit der E-Mail {text} gefunden. Bitte melden Sie sich beim Support!.</p>;
        }

        return <>
            <p>Vorname: {userForManager.user.first_name}</p>
            <p>Nachname: {userForManager.user.last_name}</p>
            <p>E-Mail: {userForManager.user.email}</p>
            <p>Unternehmen: {userForManager.user.name}</p>
            {!userForManager.user.manager && <button onClick={() => makeManager()}>Zum Manager machen</button>}
            {userForManager.user.manager && <button onClick={() => removeManager()}>Manager entfernen</button>}
        </>
    }

    return (
        <div className="managers">
            <h4>Manager ({manager.length})</h4>
            <div className="add-manager-container">
                <input
                    id="myInput"
                    placeholder="E-Mail"
                    type="text"
                    value={text}
                    onChange={(e) => setText(e.target.value.replace(/\s+/g, ""))}
                />
                {getUserForManager()}
            </div>
            <DataTable
                columns={columns}
                data={manager}
            />
        </div>
    );
}